import React, {useEffect} from 'react';
import {Input} from 'antd';
const FieldName = ({fieldValue, fieldName, value = {}, onChange}) => {

    const triggerChange = changedValue => {
        if (onChange) {
          onChange({
            ...value,
            ...changedValue
          });
        }
    };

    useEffect(() => {
        triggerChange({[fieldName]: fieldValue})
    },[])

    
    return (
        <></>
    )
}

export default FieldName;
